"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _orderDetail = _interopRequireDefault(require("./components/orderDetail"));
var _writeOffDialog = _interopRequireDefault(require("./components/writeOffDialog"));
var _orderSend = _interopRequireDefault(require("./orderSend"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@/utils");
var _permission = require("@/utils/permission");
var _directRefund = _interopRequireDefault(require("@/views/order/components/directRefund.vue"));
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
var _productEnums = require("@/enums/productEnums");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 权限判断函数
var tableFroms = {
  status: 'all',
  dateLimit: '',
  orderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  type: '',
  searchType: 'all',
  content: ''
};
var _default = exports.default = {
  name: 'orderlistDetails',
  components: {
    DirectRefund: _directRefund.default,
    detailsFrom: _orderDetail.default,
    orderSend: _orderSend.default,
    writeOffDialog: _writeOffDialog.default
  },
  data: function data() {
    return {
      RefuseVisible: false,
      RefuseData: {},
      orderNo: '',
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: '',
        text: '全部'
      }, {
        value: '0',
        text: '普通'
      }, {
        value: '1',
        text: '秒杀'
      }, {
        value: '2',
        text: '拼团'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: true,
      checkedCities: ['订单号', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      columnData: ['订单号', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      isIndeterminate: false,
      orderDatalist: null,
      merPrintStatus: _jsCookie.default.get('merPrint'),
      // 商家小票打印开关状态
      dialogVisibleDirectRefund: false,
      secondType: 0,
      //订单二级类型:0-普通订单，1-积分订单，2-虚拟订单，4-视频号订单，5-云盘订单，6-卡密订单
      type: 0,
      //订单类型
      writeOffData: {},
      // 核销订单数据
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:order:page:list'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:order:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //直接退款
    onDirectRefund: function onDirectRefund(row) {
      this.secondType = row.secondType;
      this.orderNo = row.orderNo;
      this.type = row.type;
      this.dialogVisibleDirectRefund = true;
    },
    //直接退款关闭
    handlerSuccessClose: function handlerSuccessClose() {
      this.dialogVisibleDirectRefund = false;
    },
    //直接退款成功回调
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.dialogVisibleDirectRefund = false;
      this.getList();
    },
    // 核销订单
    onWriteOff: function onWriteOff(row) {
      var _this = this;
      this.$modalPrompt('text', '核销订单', null, '核销码').then(function (V) {
        (0, _order.writeUpdateApi)({
          verifyCode: V,
          verifyCount: 1
        }).then(function () {
          _this.$message.success('核销成功');
          _this.handleSearchList();
        });
      });
    },
    handleReset: function handleReset() {
      this.tableFrom.type = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.page = 1;
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.selectChange();
    },
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 发送
    sendOrder: function sendOrder(row) {
      var _this2 = this;
      if (row.isLogoff) {
        this.$modalSure('当前用户已注销，有责发货！').then(function () {
          _this2.onSend(row);
        });
      } else {
        if (row.refundStatus == 1) return this.$message.error('请先处理售后，再进行发货/核销操作');
        this.onSend(row);
      }
    },
    handlePrintReceipt: function handlePrintReceipt(row) {
      var _this3 = this;
      this.$modalSure('确认打印小票').then(function () {
        (0, _order.orderPrintReceiptApi)(row.orderNo).then(function (data) {
          _this3.$message.success('小票打印成功');
        });
      });
    },
    //发货操作
    onSend: function onSend(row) {
      this.secondType = row.secondType;
      this.orderNo = row.orderNo;
      this.$refs.send.modals = true;
      //this.$refs.send.getList();
      this.$refs.send.orderProDetail(row.orderNo);
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this4 = this;
      if (row.isDel) {
        this.$modalSure().then(function () {
          (0, _order.orderDeleteApi)({
            orderNo: row.orderNo
          }).then(function () {
            _this4.$message.success('删除成功');
            (0, _public.handleDeleteTable)(_this4.tableData.data.length, _this4.tableFrom);
            _this4.getList();
            _this4.getOrderStatusNum();
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderNo = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.getOrderInvoiceList(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    getDetail: function getDetail(id) {
      var _this5 = this;
      this.loading = true;
      (0, _order.orderDetailApi)(id).then(function (res) {
        _this5.orderDatalist = res;
        _this5.loading = false;
      }).catch(function () {
        _this5.orderDatalist = null;
        _this5.loading = false;
      });
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this6 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      (0, _order.orderLogApi)(this.tableFromLog).then(function (res) {
        _this6.tableDataLog.data = res.list;
        _this6.tableDataLog.total = res.total;
        _this6.LogLoading = false;
      }).catch(function () {
        _this6.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this7 = this;
      this.$modalPrompt('textarea', '备注', row.merchantRemark, '订单备注').then(function (V) {
        (0, _order.orderMarkApi)({
          remark: V,
          orderNo: row.orderNo
        }).then(function () {
          _this7.$message.success('操作成功');
          _this7.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this8 = this;
      this.listLoading = true;
      (0, _order.orderListApi)(this.tableFrom).then(function (res) {
        _this8.tableData.data = res.list || [];
        _this8.tableData.total = res.total;
        _this8.listLoading = false;
        _this8.checkedCities = _this8.$cache.local.has('order_stroge') ? _this8.$cache.local.getJSON('order_stroge') : _this8.checkedCities;
      }).catch(function () {
        _this8.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this9 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.status;
      (0, _order.orderStatusNumApi)(data).then(function (res) {
        _this9.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      (0, _order.orderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkAll = true;
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this0 = this;
      (0, _order.orderPrint)(data.orderNo).then(function (res) {
        _this0.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this0.$modal.msgError(error.message);
      });
    },
    // 核销订单-table内核销
    writeOffInTable: function writeOffInTable(data) {
      var _this1 = this;
      this.writeOffData = data;
      var param = {
        orderNo: data.orderNo,
        verifyCount: 1
      };
      var orderSecondTpye = data.secondType;
      if (orderSecondTpye == this.OrderSecondTypeEnum.PunchCard) {
        this.$refs.writeOffDialog.openDialog();
      } else {
        this.$confirm('是否确认核销此订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'deleteConfirm'
        }).then(function () {
          (0, _order.writeUpdateApi)(param).then(function () {
            _this1.$message.success('核销成功');
            _this1.handleSearchList();
          });
        }).catch(function () {
          _this1.$message({
            type: 'info',
            message: '已取消核销'
          });
        });
      }
    }
  }
};